import { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./Ticket.css";
import "./menu3.css";
import io from "socket.io-client";
import { useNavigate } from "react-router-dom";
import Headers from "../Home/Header";
import Footer from "../Home/Footer";
import TicketSidebar from "../components/TicketSidebar";

axios.defaults.withCredentials = true;
const TicketDetail = () => {
  const { id } = useParams();
  const [ticket, setTicket] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [responses, setResponses] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [socket, setSocket] = useState(null);
  const hasErrorAlerted = useRef(false);
  const navigate = useNavigate();
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const fetchMessages = useCallback(async () => {
    try {
      const res = await axios.get(`/ticketadmin/message`, {
        params: { ticketNumber: id },
        withCredentials: true,
      });

      setResponses(res.data || []);
    } catch (err) {
      console.error("Error fetching messages:", err);
    }
  }, [id]);

  useEffect(() => {
    scrollToBottom();
  }, [responses]);

useEffect(() => {
  const socketConnection = io(
    "",
    {
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    },
  );

  setSocket(socketConnection);

  const handleConnect = () => {
  };

  const handleDisconnect = (reason) => {
  };

  const handlePageShow = (event) => {
    if (
      event.persisted &&
      !socketConnection.connected
    ) {
      socketConnection.connect();
    }
  };

  socketConnection.on(
    "connect",
    handleConnect,
  );

  socketConnection.on(
    "disconnect",
    handleDisconnect,
  );

  window.addEventListener(
    "pageshow",
    handlePageShow,
  );

  return () => {
    window.removeEventListener(
      "pageshow",
      handlePageShow,
    );

    socketConnection.off(
      "connect",
      handleConnect,
    );

    socketConnection.off(
      "disconnect",
      handleDisconnect,
    );

    socketConnection.disconnect();
  };
}, []);
  useEffect(() => {
    axios
      .get(`/api/ticket/${id}`)
      .then((res) =>
        setTicket(Array.isArray(res.data) ? res.data[0] : res.data),
      )
      .catch((err) => {
        const status = err?.response?.status;
        const message = "ไม่พบ ticket นี้";
        if (status === 403 || status === 404) {
          if (!hasErrorAlerted.current) {
            alert(message);
            hasErrorAlerted.current = true;
          }
          setErrorMessage(message);
          navigate("/customer/tickets");
          return;
        }
        setTicket(null);
        console.error("Error fetching ticket:", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id, navigate]);

  useEffect(() => {
    if (!ticket) return;
    fetchMessages();
  }, [ticket, fetchMessages]);

  useEffect(() => {
    if (socket) {
      socket.on("ticketResponse", (messageData) => {
        const normalizedMessage = {
          ...messageData,
          senderType:
            messageData.senderType ||
            (messageData.employee_id ? "admin" : "customer"),
          senderName: messageData.senderName || messageData.sender_name || null,
          Message: messageData.Message || messageData.message || "",
        };

        setResponses((prev) => {
          const exists = prev.some((msg) => msg.id === normalizedMessage.id);
          if (exists) return prev;

          return [...prev, normalizedMessage];
        });
      });
    }

    return () => {
      if (socket) {
        socket.off("ticketResponse");
      }
    };
  }, [socket]);

  useEffect(() => {
    if (socket && ticket?.id) {
      socket.emit("joinTicket", { ticketNumber: ticket.id });

      return () => {
        socket.emit("leaveTicket", { ticketNumber: ticket.id });
      };
    }
  }, [socket, ticket?.id]);

  const formatDate = (input) => {
    if (!input) return "N/A";
    const date = new Date(input);
    return date.toLocaleString("th-TH", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    const max = 100 * 1024 * 1024;
    const tooBig = files.find((f) => f.size > max);
    if (tooBig) {
      alert(`File "${tooBig.name}" exceeds 100MB`);
      event.target.value = null;
      setSelectedFiles([]);
      return;
    }
    setSelectedFiles(files);
  };

  const uploadFiles = async () => {
    if (!selectedFiles || selectedFiles.length === 0) return [];
    const names = [];
    try {
      setIsUploading(true);
      for (const f of selectedFiles) {
        const formData = new FormData();
        formData.append("file", f);
        const res = await axios.post(
          `/fileuploads/upload`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } },
        );
        if (res?.data?.filename) names.push(res.data.filename);
      }
    } catch (err) {
      alert("Failed to upload file(s)");
      return [];
    } finally {
      setIsUploading(false);
    }
    return names;
  };

  const handleSendMessage = async () => {
  if (
    (!newMessage.trim() && selectedFiles.length === 0) ||
    !ticket
  ) {
    return;
  }

  try {
    const fileNames = await uploadFiles();

    const messageData = {
      ticket_id: ticket.id,
      message: newMessage.trim(),
      AttachFiles: fileNames,
    };

    await axios.post(
      "/ticketadmin/message",
      messageData,
      {
        withCredentials: true,
      },
    );

    setNewMessage("");
    setSelectedFiles([]);

    const el = document.getElementById("file-upload");

    if (el) {
      el.value = "";
    }

    await fetchMessages();
  } catch (err) {
    console.error(
      "Send message error:",
      err.response?.data || err,
    );

    alert(
      err.response?.data?.error ||
        "ไม่สามารถส่งข้อความได้",
    );
  }
};
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSendMessage();
    }
  };

  const handleOpenAsset = () => {
    if (!ticket?.customer_asset_id) return;
    navigate(`/customer/assets-list/${ticket.customer_asset_id}`);
  };

  const shouldShowRepairAction = Boolean(ticket?.repair_case_type_id);
  const isReplaceNewDevice = Number(ticket?.repair_case_type_id) === 1;
  const repairActionText = ticket?.repair_case_type_name_th || "-";
  const repairChangedSerial = ticket?.repair_changed_serial || "";

  if (!isLoading && !ticket) {
    return (
      <>
        <Headers />
        <TicketSidebar active="/customer/tickets/" />
        <div className="ticket-detail-page">
          <button
            className="back-btn"
            onClick={() => navigate("/customer/tickets")}
            style={{ marginLeft: "10px" }}
          >
            Back
          </button>
          <div
            style={{
              border: "1px solid #ccc",
              padding: "16px",
              marginTop: "16px",
              borderRadius: "4px",
              backgroundColor: "#fafafa",
              maxWidth: "1500px",
            }}
          >
            <p style={{ margin: 0, fontSize: "16px", color: "#333" }}>
              {errorMessage || "ไม่พบ ticket นี้"}
            </p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Headers />
      <div className="ticket-layout-page">
        <TicketSidebar active="/customer/tickets/" />
        <div className="ticket-detail-page">
          <button
            className="back-btn"
            onClick={() => navigate("/customer/tickets")}
            style={{ marginLeft: "10px" }}
          >
            Back
          </button>

          <h2>Ticket #{id}</h2>
          <div
            style={{
              border: "1px solid #ccc",
              padding: "10px",
              marginBottom: "16px",
              borderRadius: "4px",
              backgroundColor: "#fafafa",
              maxWidth: "1500px",
            }}
          >
            <div
              className="ticket-info-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridTemplateRows: "auto auto",
                gap: "25px",
                alignItems: "center",
              }}
            >
              <h3>Report: {ticket?.issue_summary}</h3>

              <p style={{ margin: 0 }}>
                <strong>User:</strong> {ticket?.name || "-"}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Created At:</strong> {formatDate(ticket?.created_at)}
              </p>
              <p style={{ margin: 0, textAlign: "left" }}>
                <strong>Help Topic:</strong> {ticket?.help_topic || "-"}
              </p>

              <p style={{ margin: 0 }}>
                <strong>Email:</strong> {ticket?.email || "-"}
              </p>
              <p style={{ margin: 0, textAlign: "left" }}>
                <strong>Status:</strong> {ticket?.status || "-"}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Serial Number:</strong>{" "}
                {ticket?.customer_asset_id ? (
                  <>
                    <a
                      href={`/customer/assets-list/${ticket.customer_asset_id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleOpenAsset();
                      }}
                      style={{
                        color: "#2563eb",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontWeight: 500,
                      }}
                    >
                      {ticket?.customer_asset_serial || "-"}
                    </a>
                    {ticket?.customer_asset_product ? (
                      <span style={{ marginLeft: "8px" }}>
                        {ticket.customer_asset_product}
                      </span>
                    ) : null}
                  </>
                ) : (
                  "-"
                )}
              </p>
              {shouldShowRepairAction && (
                <div className="customer-ticket-repair-box">
                  <div className="customer-ticket-repair-title">
                    Repair Action:
                  </div>

                  <div className="customer-ticket-repair-content">
                    <span className="customer-ticket-repair-label">
                      รายการดำเนินการ:
                    </span>

                    <span className="customer-ticket-repair-value">
                      {repairActionText}
                    </span>
                  </div>

                  {isReplaceNewDevice && (
                    <div className="customer-ticket-repair-message">
                      มีการเปลี่ยนเครื่อง / เปลี่ยน Serial ใหม่จาก Ticket นี้
                      {repairChangedSerial ? (
                        <>
                          {" "}
                          โดย Serial ใหม่คือ{" "}
                          <strong>{repairChangedSerial}</strong>
                        </>
                      ) : (
                        " แต่ยังไม่พบข้อมูล Serial ใหม่ในประวัติ"
                      )}
                    </div>
                  )}

                  {ticket?.repair_result_note && (
                    <div className="customer-ticket-repair-message">
                      <strong>ผลการดำเนินการ:</strong>{" "}
                      {ticket.repair_result_note}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <h3>Conversation:</h3>
          <div className="chat-messages">
            {responses.length === 0 ? (
              <div className="conversation-empty-state">ยังไม่มีการสนทนา</div>
            ) : (
              responses.map((res) => {
                const isAdmin =
                  res.senderType === "admin" ||
                  (res.employee_id !== null &&
                    res.employee_id !== undefined &&
                    String(res.employee_id).trim() !== "");

                const isCustomer = res.senderType === "customer" || !isAdmin;

                return (
                  <div
                    key={res.id}
                    className={`chat-message ${
                      isCustomer ? "cus-message" : "admin-message2"
                    }`}
                  >
                    <div className="message-text">{res.Message}</div>

                    {res.AttachFiles && (
                      <div className="attachment">
                        {(() => {
                          let files = [];

                          if (Array.isArray(res.AttachFiles)) {
                            files = res.AttachFiles.map((s) =>
                              String(s || "").trim(),
                            ).filter(Boolean);
                          } else if (typeof res.AttachFiles === "string") {
                            files = res.AttachFiles.split(",")
                              .map((s) => s.trim())
                              .filter(Boolean);
                          }

                          if (files.length === 0) return null;

                          return (
                            <ul
                              style={{
                                padding: 0,
                                margin: 0,
                                listStyle: "none",
                              }}
                            >
                              {files.map((fname, idx) => (
                                <li
                                  key={idx}
                                  style={{ margin: "2px 0", lineHeight: 1.2 }}
                                >
                                  <a
                                    href={`/fileuploads/${encodeURIComponent(
                                      fname,
                                    )}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      display: "inline-block",
                                      textDecoration: "none",
                                    }}
                                  >
                                    📄 {fname}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          );
                        })()}
                      </div>
                    )}

                    <div className="message-meta">
                      <span>
                        {isAdmin
                          ? `From: Admin (${res.senderName || "Unknown"})`
                          : `From: ${res.senderName || "Customer"}`}
                      </span>
                      <span>{formatDate(res?.created_at)}</span>
                    </div>
                  </div>
                );
              })
            )}

            <div ref={messagesEndRef} />
          </div>

          <div className="chat-input-container">
            <textarea
              className="chat-input"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Type your message here..."
              rows="4"
              style={{ whiteSpace: "pre-wrap" }}
            />
            <div className="chat-actions">
              <input
                type="file"
                id="file-upload"
                multiple
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <label htmlFor="file-upload" className="file-upload-button">
                {selectedFiles.length > 0
                  ? `📎 ${selectedFiles.length} file(s)`
                  : "📎 Attach File"}
              </label>
              <button
                className="chat-send-button"
                onClick={handleSendMessage}
                disabled={isUploading || (!newMessage.trim() && !selectedFiles)}
              >
                {isUploading ? "Uploading..." : "Send"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TicketDetail;
